import { render } from "./ExpiredPage.vue?vue&type=template&id=3670d8ab"
import script from "./ExpiredPage.vue?vue&type=script&lang=js"
export * from "./ExpiredPage.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Sources\\Repos\\TaskApi\\TaskApp.VueCore\\clientTaskApp\\clientTaskApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__